const CONSENT_COOKIE_NAME = '_evidon_consent_cookie';
const CUSTOM_CONSENT_COOKIE = '_rbx_consent_cookie';

export { CONSENT_COOKIE_NAME, CUSTOM_CONSENT_COOKIE };
